import axios from "axios";
import React, { useState, useEffect, useContext, useMemo } from "react";
import { useParams } from "react-router-dom";
import "./networks.scss";
import Maps from "./maps";
import Breadcrumbs from "../../common/breadcumb";
import { LangContext } from "../../context/LangContext";
import Loading from "../../common/loading";
import Errors from "../../common/error";
function BranchAndATM() {
  const { state } = useContext(LangContext);
  const nep = state.np;
  let { slug } = useParams(null);
  if (slug == "atm-location") {
    slug = "atm";
  }
  if (slug == "extension-counter") {
    slug = "extension";
  }
  const [networks, setNetworks] = React.useState();
  const APIURL = `${process.env.REACT_APP_URL}${slug}`;
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(false);
  const [selectedBranch, setSelectedBranch] = React.useState({
    id: null,
    lat: null,
    lng: null,
  });
  React.useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        setError(false);
        const response = await axios.get(APIURL);
        if (slug === "extension") {
          setNetworks(response.data?.extension);
        } else {
          setNetworks(response.data?.branch);
        }
        setLoading(false);
      } catch (error) {
        setError(true);
        setLoading(false);
      }
    })();
  }, [slug]);
  const mainDataCat = useMemo(() => {
    if (!networks) return [];
    return nep ? networks.np : networks.en;
  }, [networks, nep]);
  const pageTitle = useMemo(() => {
    switch (slug) {
      case "branches":
        return nep ? "शाखाहरू" : "Branches";
      case "extension":
        return nep ? "विस्तारित काउन्टर" : "Extension Counter";
      case "atm":
        return nep ? "एटीएम स्थान" : "ATM Location";
      case "member-network":
        return nep ? "सदस्य नेटवर्क" : "Member Network";
      default:
        return slug;
    }
  }, [slug, nep]);
  if (loading) return <Loading />;
  if (error) return <Errors />;
  const branchChange = (event) => {
    setSelectedBranch({
      id: event.target.getAttribute("data-id"),
      lat: Number(event.target.getAttribute("data-lat")),
      lng: Number(event.target.getAttribute("data-lng")),
    });
  };

  return (
    <>
      <Breadcrumbs PageTitle={pageTitle} />
      <div className="InsidePageContainer" role="main">
        <div className="branchesMainBox">
          <div className="wrapper">
            <div className="branch-container">
              <div className="BranchesItemList">
                <div className="accordion" id="accordionExample">
                  {mainDataCat?.map((network, index) => {
                    return (
                      <div key={index} className="accordion-item">
                        <h2
                          className="accordion-header"
                          id="headingOne"
                          onClick={branchChange}
                        >
                          <button
                            className="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#collapseOne-${network.id}`}
                            aria-expanded="true"
                            aria-controls="collapseOne"
                            data-id={network.id}
                            data-lat={network.latitude}
                            data-lng={network.longitude}
                          >
                            {network.title}
                          </button>
                        </h2>
                        <div
                          key={index}
                          id={`collapseOne-${network.id}`}
                          className={`accordion-collapse collapse ${
                            index == 0 ? "show" : ""
                          } `}
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            <div className="branchesData">
                              <p>
                                <strong>
                                  {nep ? "ठेगाना : " : "Address : "}{" "}
                                </strong>{" "}
                                {network.address}
                              </p>
                              <p>
                                <strong>
                                  {nep ? "फोन नम्बर : " : " Phone Number : "}{" "}
                                </strong>
                                {network.phone}
                              </p>
                              <p>
                                <strong>
                                  {(slug == "branches" && network.id == 17) ||
                                  (slug == "branches" && network.id == 20) ||
                                  (slug == "branches" && network.id == 13) ||
                                  (slug == "branches" && network.id == 4)
                                    ? nep
                                      ? "क्षेत्रीय प्रबन्धक : "
                                      : "Regional Manager : "
                                    : ""}
                                </strong>
                                {network.RMname}
                              </p>
                              <p>
                                <strong>
                                  {slug == "extension"
                                    ? nep
                                      ? "इन्चार्ज : "
                                      : "Incharge : "
                                    : network.id == 1
                                    ? ""
                                    : network.id == 17 ||
                                      network.id == 20 ||
                                      network.id == 13 ||
                                      network.id == 4
                                    ? network.manager_tag === "Branch Manager"
                                      ? nep
                                        ? "शाखा प्रबन्धक : "
                                        : "Branch Manager : "
                                      : nep
                                      ? " का.मु शाखा प्रबन्धक : "
                                      : "Acting Branch Manager : "
                                    : network.manager_tag === "Branch Manager"
                                    ? nep
                                      ? "शाखा प्रबन्धक : "
                                      : "Branch Manager : "
                                    : nep
                                    ? "का.मु शाखा प्रबन्धक : "
                                    : "Acting Branch Manager :"}
                                </strong>
                                {network.manager}
                              </p>
                              <p>
                                <strong>{nep ? "इमेल : " : "Email : "} </strong>
                                {network.email}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="BranchesMaps">
                <Maps data={mainDataCat} selected={selectedBranch} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BranchAndATM;
